import React, { useRef, useState } from "react";
import { Paperclip, X, CircleNotch, VideoCamera, ImageSquare } from "@phosphor-icons/react";
import { MAX_FILES } from "./useAttachments";

function Thumb({ it, onRemove }) {
  const [broken, setBroken] = useState(false);
  const Icon = it.kind === "video" ? VideoCamera : ImageSquare;
  return (
    <div className="relative aspect-square rounded-lg overflow-hidden border border-neutral-800 bg-black/40" data-testid="ticket-attachment-item">
      {broken ? (
        <div className="w-full h-full flex flex-col items-center justify-center gap-1 p-1.5 text-neutral-500">
          <Icon size={20} /><span className="text-[0.6rem] truncate max-w-full">{it.name}</span>
        </div>
      ) : it.kind === "photo" ? (
        <img src={it.url} alt={it.name} onError={() => setBroken(true)} className="w-full h-full object-cover" />
      ) : (
        <video src={it.url} muted playsInline preload="metadata" onError={() => setBroken(true)} className="w-full h-full object-cover" />
      )}
      {it.kind === "video" && !broken && (
        <span className="absolute bottom-1 left-1 bg-black/70 rounded-full p-1 text-white"><VideoCamera size={11} weight="fill" /></span>
      )}
      {!it.uploadId && (
        <div className="absolute inset-0 bg-black/65 flex flex-col items-center justify-center gap-1.5" data-testid="ticket-attachment-uploading">
          <CircleNotch size={16} className="animate-spin text-[#73bf44]" />
          <span className="text-[0.65rem] text-white tabular-nums">{it.progress}%</span>
          <div className="h-1 w-3/4 bg-white/10 rounded-full overflow-hidden">
            <div className="h-full bg-[#73bf44] transition-[width] duration-200" style={{ width: `${it.progress}%` }} />
          </div>
        </div>
      )}
      <button type="button" onClick={onRemove} aria-label={`Remove ${it.name}`} data-testid="ticket-attachment-remove"
        className="absolute top-1 right-1 bg-black/75 rounded-full p-1 text-white hover:bg-red-500/80 transition-colors">
        <X size={12} />
      </button>
    </div>
  );
}

export function AttachmentPicker({ att }) {
  const ref = useRef(null);
  const full = att.items.length >= MAX_FILES;
  return (
    <div>
      <input ref={ref} type="file" accept="image/*,video/*" multiple className="hidden" data-testid="ticket-attachments-input"
        onChange={(e) => { att.add(e.target.files); e.target.value = ""; }} />
      <button type="button" onClick={() => ref.current?.click()} disabled={full} data-testid="ticket-attachments-pick"
        className="w-full border border-dashed border-neutral-700 rounded-xl py-4 flex items-center justify-center gap-2.5 text-sm text-neutral-400 hover:border-[#73bf44] hover:text-white transition-colors disabled:opacity-50 disabled:hover:border-neutral-700">
        <Paperclip size={17} /> {full ? `Maximum ${MAX_FILES} files added` : "Add photos or videos"}
      </button>
      <p className="text-[0.65rem] text-neutral-600 mt-1.5">Up to {MAX_FILES} files · photos up to 25MB · videos up to 200MB each</p>
      {att.items.length > 0 && (
        <div className="grid grid-cols-4 sm:grid-cols-5 gap-2 mt-3" data-testid="ticket-attachments-grid">
          {att.items.map((it) => <Thumb key={it.key} it={it} onRemove={() => att.remove(it.key)} />)}
        </div>
      )}
    </div>
  );
}
